import { Box, Button, Flex, Text, VStack } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { PropertyFieldsProvider } from "../providers/property-fields-provider";
import { usePropertyFields } from "../providers/property-fields-context";
import { FormProvider } from "react-hook-form";
import { PropertyFieldsReadOnly } from "./read-only/property-fields-read-only";
import { PropertyFieldsEditable } from "./editable/templates/property-fields-editable";

export function PropertyFieldViewContent() {
  const { isEditing, setIsEditing, form, handleSubmit, isSubmitting } = usePropertyFields();
  const { user } = useTenant();

  const propertyTemplateName =
    user?.company?.company_configurations?.[0]?.field_controls?.property_detail_template ||
    "default";

  if (propertyTemplateName !== "default") {
    return <Text>Property template not found</Text>;
  }

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit}>
        <Box position="absolute" top={4} right={4}>
          {isEditing ? (
            <Flex alignItems="center" gap={2}>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setIsEditing(false)}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button type="submit" colorScheme="primary" size="sm" isLoading={isSubmitting}>
                Save Changes
              </Button>
            </Flex>
          ) : (
            <Button variant="white" size="sm" onClick={() => setIsEditing(true)}>
              Edit Details
            </Button>
          )}
        </Box>

        <VStack gap={4}>
          {isEditing ? <PropertyFieldsEditable /> : <PropertyFieldsReadOnly />}
        </VStack>
      </form>
    </FormProvider>
  );
}

type PropertyFieldViewProps = {
  propertyId: number;
};

export function PropertyFieldView({ propertyId }: PropertyFieldViewProps) {
  return (
    <PropertyFieldsProvider propertyId={propertyId}>
      <PropertyFieldViewContent />
    </PropertyFieldsProvider>
  );
}
